import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'list', 'field']

  connect() {
    this.tags = []
    this.loadFromField()
    this.render()
  }

  handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ',') {
      event.preventDefault()
      this.commitInputValue()
    }
  }

  commitInput() {
    this.commitInputValue()
  }

  removeTag(event) {
    event.preventDefault()
    const value = event.params.value
    this.tags = this.tags.filter(tag => tag !== value)
    this.updateField()
    this.render()
  }

  loadFromField() {
    if (!this.hasFieldTarget) return
    const raw = this.fieldTarget.value
    if (!raw) return

    try {
      const parsed = JSON.parse(raw)
      this.tags = Array.isArray(parsed) ? parsed.map(tag => tag.toString()) : []
    } catch (_error) {
      this.tags = raw.split(',').map(entry => entry.trim()).filter(Boolean)
    }
  }

  commitInputValue() {
    if (!this.hasInputTarget) return
    const value = (this.inputTarget.value || '').trim()
    if (!value) return

    if (!this.tags.includes(value)) {
      this.tags.push(value)
      this.updateField()
      this.render()
    }

    this.inputTarget.value = ''
  }

  updateField() {
    if (!this.hasFieldTarget) return
    this.fieldTarget.value = JSON.stringify(this.tags)
  }

  render() {
    if (!this.hasListTarget) return
    this.listTarget.innerHTML = ''
    this.tags.forEach(tag => {
      const badge = document.createElement('span')
      badge.className = 'inline-flex items-center rounded-full bg-indigo-100 px-2 py-1 text-xs text-indigo-700'
      badge.textContent = tag

      const removeButton = document.createElement('button')
      removeButton.type = 'button'
      removeButton.className = 'ml-2 text-indigo-500 hover:text-indigo-700'
      removeButton.innerHTML = '&times;'
      removeButton.dataset.action = 'tag-input#removeTag'
      removeButton.dataset.tagInputValueParam = tag
      badge.appendChild(removeButton)

      this.listTarget.appendChild(badge)
    })
  }
}
